//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SidebarComponent",
  computed: {
    drawer: {
      get() {
        return this.$store.state.sidebar.display;
      },
      set() {
        return this.$store.dispatch("sidebar/toggle");
      }
    },
    items: {
      get() {
        return this.$store.state.sidebar.items;
      },
      set() {
        this.$store.dispatch(
          "sidebar/setMenu",
          JSON.parse(localStorage.getItem("user").menuitems)
        );
      }
    }
  }
};
